import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';

@Pipe({
    name: 'contentInformation',
    standalone: false
})
export class InformationPipe implements PipeTransform {

  constructor(private contentPipeService: ContentPipeService) {
  }

  transform(entry: any): Models.InformationEntry {
    if (!entry || (!entry.content && !entry.title)) {
      return null;
    }

    const informationEntry: any = new Models.InformationEntry();
    informationEntry.populateFromJSON({
      sourceId: entry._id,
      title: entry.title,
      documents: this.contentPipeService.getDocuments(entry),
      media: this.contentPipeService.getMedia(entry),
      iFrameUrl: entry?.content?.iframe ? entry.content.iframe : null
    });
    informationEntry.contentType = 'information';
    informationEntry.description = entry?.content?.textContent || informationEntry?.description;
    if (entry && entry.content) {
      if (entry.content.website && !informationEntry.description && !informationEntry.documents.length &&
        !informationEntry.media.length && !informationEntry.bookable && !informationEntry.bookingUrl) {
        informationEntry.iFrameUrl = entry.content.website;
      }

      if (entry.content.location) {
        informationEntry.street = entry.content.location.address;
        informationEntry.city = entry.content.location.city;
        informationEntry.zip = entry.content.location.zip;
        if (entry.content.location.coordinates) {
          informationEntry.latitude = entry.content.location.coordinates.latitude;
          informationEntry.longitude = entry.content.location.coordinates.longitude;
        }
      }
      if (entry.content.bookable && entry.content.bookingUrl) {
        informationEntry.bookable = entry.content.bookable;
        informationEntry.bookingUrl = entry.content.bookingUrl;
        informationEntry.bookingText = entry.content.bookingText;
      }
      if (entry?.content?.contact?.[0]?.variants && Array.isArray(entry.content.contact[0].variants)) {
        informationEntry.phone = entry.content.contact[0].variants.find(e => e.type === 'phone')?.value || informationEntry.phone;
        informationEntry.fax = entry.content.contact[0].variants.find(e => e.type === 'fax')?.value || informationEntry.fax;
        informationEntry.email = entry.content.contact[0].variants.find(e => e.type === 'email')?.value || informationEntry.email;
      }
    }

    return informationEntry;
  }

}
